<template><div><h1>date format</h1>
<p>Built-in dateFormat is much smaller size than <code>moment</code>。</p>
<h2>Usage</h2>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { dateFormat } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>

dateFormat(<span class="hljs-keyword">new</span> <span class="hljs-built_in">Date</span>(), <span class="hljs-string">'YYYY-MM-DD HH:mm:ss'</span>)
</code></pre>
<h2>Used as Vue filter</h2>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { dateFormat } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>

<span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
  <span class="hljs-attr">filters</span>: {
    dateFormat
  }
}

</code></pre>
</div></template><script>
export default {
  head: {"title":"vue date format | VUX - Vue 移动端 UI 组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// date-181.vue?5f363e4e